import React from "react";

import cx from "classnames";

export type CardHeaderProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const CardHeader: React.FC<React.PropsWithChildren<Readonly<CardHeaderProps>>> = ({
  className,
  children,
  ...props
}) => (
  <div {...props} className={cx("bg-white px-4 py-2 sm:px-6", className)}>
    {children}
  </div>
);
